import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import {TwoLineInfo} from './two-line-info';

type Props = {
    outcome: 'CANCELLED' | 'LOST';
    reason: string;
};

export function LeadOutcomeReason(props: Props) {
    const body = (
        <Stack isHorizontal={true} spacing={4} alignItems='center'>
            <Body>{props.reason}</Body>
        </Stack>
    );

    return (
        <TwoLineInfo
            header={props.outcome === 'CANCELLED' ? 'Cancel reason' : 'Lost reason'}
            body={body}
        />
    );
}
